module.exports = __webpack_public_path__ + "img/remove-white.7fc77758.svg";